import { mutatorAction } from 'satcheljs';
import { updateFolderViewState } from './folderViewStatesActions';
import getFolderViewStateFromId from '../selectors/getFolderViewStateFromId';
import { setFolderViewStateInner } from '../actions/setFolderViewState';
import type { MailboxInfo } from 'owa-client-types';
import { getFolderTable } from 'owa-folders';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { lazyUpdateMailboxFolderExpansionState } from '../lazyFunctions';
import { trace } from 'owa-trace';
import { markMailboxFolderExpansionChanged } from '../utils/mailboxFolderExpansionChanges';

const toggleFolderNodeExpansionMutator: (
    folderId: string,
    mailboxInfo: MailboxInfo | undefined,
    persistFolderViewState: boolean
) => void = mutatorAction(
    'toggleFolderNodeExpansion',
    function (
        folderId: string,
        mailboxInfo: MailboxInfo | undefined,
        persistFolderViewState: boolean
    ): void {
        const localViewState = getFolderViewStateFromId(folderId);
        localViewState.isExpanded = !localViewState.isExpanded;
        // A later lazy restoration must not overwrite this interaction.
        localViewState.hasResolvedMailboxExpansion = true;
        setFolderViewStateInner(folderId, localViewState);
        markMailboxFolderExpansionChanged(folderId);

        if (persistFolderViewState) {
            updateFolderViewState(folderId, mailboxInfo, true /* skipMutator */);
        }
    }
);

export default function toggleFolderNodeExpansion(
    folderId: string,
    mailboxInfo?: MailboxInfo,
    doNotPersistUserConfig?: boolean
): void {
    const folderMailboxInfo = getFolderTable().get(folderId)?.mailboxInfo;
    const persistMailboxExpansion =
        isGlobalFeatureEnabled('fp-persist-mailbox-folder-expansion') &&
        (folderMailboxInfo?.type === 'SharedMailbox' ||
            folderMailboxInfo?.type === 'ArchiveMailbox');
    toggleFolderNodeExpansionMutator(
        folderId,
        mailboxInfo,
        !doNotPersistUserConfig && !persistMailboxExpansion
    );

    if (!doNotPersistUserConfig && persistMailboxExpansion && folderMailboxInfo) {
        const isExpanded = getFolderViewStateFromId(folderId).isExpanded === true;
        void lazyUpdateMailboxFolderExpansionState
            .importAndExecute(folderId, folderMailboxInfo, isExpanded)
            .catch(() => {
                trace.warn('Failed to update mailbox folder expansion preferences.');
            });
    }
}
